import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDashService } from 'contact-dash';
import { Observable } from 'rxjs';
import { FilterParams, IUserAccountModel } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class UserDataService extends UserDashService {
  protected _getPasswordScoreUri = '/api/User/CheckPasswordScore/';
  protected _getUserAccountDataUri = '/api/User';
  protected _getMyAccountUri = '/api/User/GetMyAccount';
  protected _getUserGroupsUri = '/api/LU_UserGroups';
  protected _postUserGroupLinksUri = '/api/UserGroupLinkModels';
  protected _deleteUserGroupLinksUri = '/api/UserGroupLinkModels/';
  protected _resetUserLockoutUri = '/api/User/ResetUserLockout?id=';
  protected _changePasswordUri = '/api/User/ChangePassword';
  protected _changeDisplayNameUri = '/api/User/ChangeDisplayName';
  protected _passwordScoreUri = '/api/User/CheckPasswordScore?pwd=';
  protected _getUsernameAllowedUri = '/api/User/GetUserNameAllowed?user=';
  protected _passwordResetRequestUri = '/api/User/PasswordResetRequestForSite?user=';
  protected _confirmPwdResetUri = '/api/User/ConfirmPasswordReset?';
  protected _confirmPwdResetForSiteUri = '/api/User/ConfirmPasswordResetForSite?';
  protected _signupNewAccountUri = '/api/User/SignupNewAccount';
  protected _staleDataTimeout = 1500;
  protected _getOneUri = '/api/User/';
  protected _getAllUri = '';
  protected _postUri = '/api/User';
  protected _putUri = '/api/User/EditUserAccountModel?id=';
  protected _deleteUri = '/api/User/';
  protected _broadSearchUri = '';
  private resendConfirmationEmailUri = '/api/User/ResendConfirmationEmailForSite?site=';

  constructor(private _http: HttpClient, private _webApi: WebApiService) {
    super(_http, _webApi);
   }

  getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<IUserAccountModel>):
    Observable<FilterParams<IUserAccountModel>> {
    throw new Error('Method not implemented.');
  }

  public confirmPasswordResetForSite(email: string, pwd: string, token: string, site: string) {
    return this._http.put(
      `${this.server}${this._confirmPwdResetForSiteUri}token=${token}&pwd=${pwd}&email=${email}&site=${site}`,
      {},
      { headers: this._webApi.getApiHeaders('put') }
    );
  }

  public resendConfirmationEmail(user: string, site: number): Observable<any> {
    return this.postRequisiteData(this.resendConfirmationEmailUri + site, `"${user}"`);
  }
}
